"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VaultReentrancyLib__factory = void 0;
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
const ethers_1 = require("ethers");
const _abi = [
    {
        inputs: [],
        name: "Reentry",
        type: "error",
    },
];
const _bytecode = "0x60808060405234601757603a9081601d823930815050f35b600080fdfe600080fdfea2646970667358221220fbd8a3f2f7170e476bd146eaceae2e791e0e804f98fcc5e0a2d22bc911a05b3f64736f6c634300081a0033";
const isSuperArgs = (xs) => xs.length > 1;
class VaultReentrancyLib__factory extends ethers_1.ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    connect(runner) {
        return super.connect(runner);
    }
    static createInterface() {
        return new ethers_1.Interface(_abi);
    }
    static connect(address, runner) {
        return new ethers_1.Contract(address, _abi, runner);
    }
}
exports.VaultReentrancyLib__factory = VaultReentrancyLib__factory;
VaultReentrancyLib__factory.bytecode = _bytecode;
VaultReentrancyLib__factory.abi = _abi;
//# sourceMappingURL=VaultReentrancyLib__factory.js.map